"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _Site = require("./Site.styles");

function composeFilteredProjects(projects, matches, shouldFilter) {
  if (!shouldFilter) {
    return {
      included: projects,
      excluded: []
    };
  }

  const included = projects.filter(project => matches.has(project.project_pk));
  const excluded = projects.filter(project => !matches.has(project.project_pk));
  return {
    included,
    excluded
  };
}

const Projects = ({
  projects,
  matches,
  onClick,
  active,
  shouldFilter = false
}) => {
  const {
    included,
    excluded
  } = composeFilteredProjects(projects, matches, shouldFilter);
  return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, included.map(project => /*#__PURE__*/_react.default.createElement(_Site.$Project, {
    disabled: project.project_pk === active.project_pk,
    active: project.project_pk === active.project_pk,
    onClick: onClick(project.project_pk),
    key: project.project_pk
  }, /*#__PURE__*/_react.default.createElement("span", null, project.project_name), ' ', /*#__PURE__*/_react.default.createElement("span", null, project.sites.length))), excluded.map(project => /*#__PURE__*/_react.default.createElement(_Site.$Project, {
    disabled: true,
    noMatch: true,
    onClick: onClick(project),
    key: project.project_pk
  }, project.project_name)));
};

var _default = Projects;
exports.default = _default;
module.exports = exports.default;